import {AG_GRID_LOCALE_EN} from '../constants/i18n/locale.en';
import { AG_GRID_LOCALE_IT } from '../constants/i18n/locale.it';
export class AgGridLangMap {
  map: any;

  constructor(lang: string) {
    if (lang === 'it' || lang === 'en') {
      this.map = lang === 'it' ? AG_GRID_LOCALE_IT : AG_GRID_LOCALE_EN;
    }
  }

  public getOf(key: string) {
    if (this.map) {
      const t = this.map[key];
      if (t !== null) {
        return t;
      }
    }
    return '';
  }

}
